import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { IMPORT_MAX_ROWS, parseCsv, ParsedCsv } from './importCsv';
import { contactsMessages as messages } from './contactsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Step 1 of the import (design outreach q3): pick a CSV file; the browser reads it. */
const ImportFileStepComponent: React.FC<{ onFile: (name: string, csv: ParsedCsv) => void }> = ({ onFile }) => {
  const intl = useIntl();
  const [problem, setProblem] = useState<'bad' | 'large' | null>(null);

  const read = (file: File) => {
    file
      .text()
      .then((text) => {
        const csv = parseCsv(text);
        if (csv.headers.length === 0 || csv.rows.length === 0) {
          setProblem('bad');
          return;
        }
        if (csv.rows.length > IMPORT_MAX_ROWS) {
          setProblem('large');
          return;
        }
        setProblem(null);
        onFile(file.name, csv);
      })
      .catch(() => setProblem('bad'));
  };

  return (
    <>
      <p className={styles.sub}>{intl.formatMessage(messages.fileBody, { max: intl.formatNumber(IMPORT_MAX_ROWS) })}</p>
      <label className={styles.label} htmlFor="outreach-import-file">
        {intl.formatMessage(messages.fileLabel)}
      </label>
      <input
        id="outreach-import-file"
        type="file"
        accept=".csv,text/csv"
        className="form-control"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file !== undefined) {
            read(file);
          }
        }}
      />
      {problem === 'bad' && <p className="text-danger mb-0">{intl.formatMessage(messages.badFile)}</p>}
      {problem === 'large' && (
        <p className="text-danger mb-0">
          {intl.formatMessage(messages.tooLarge, { max: intl.formatNumber(IMPORT_MAX_ROWS) })}
        </p>
      )}
    </>
  );
};

export const ImportFileStep = TypedMemo(ImportFileStepComponent);
